// Top level routes
export const LANDING = '/'
export const EMAIL_LOGIN = '/email-login'

// Email login routes
export const MAGIC_LINK = '/email-login/magic-link'
export const LOGIN = '/email-login/login'

// Profile
export const PROFILE = '/profile'
export const SIGN_UP = '/sign-up'

// Quizzes
export const QUIZZES = '/quizzes'
export const QUIZZES_NEW = '/quizzes/new'
export const NEW_QUIZ = '/quizzes/new/:id'
export const QUIZZES_COMPLETED = '/quizzes/completed'
export const COMPLETE_QUIZ = '/quizzes/completed/:id'

// Leaderboard
export const LEADER_BOARD = '/leaderboard'
export const LEADER_BOARD_DETAIL = '/leaderboard/:id'

// Notifications
export const NOTIFICATIONS = '/notifications'

// Terms and others
export const TERMS = '/terms'
export const PRIVACY = '/privacy'
